// extracted by mini-css-extract-plugin
module.exports = {"serviceExpertise":"style_serviceExpertise__ivL9A","serviceExpertise__title":"style_serviceExpertise__title__GWKLl"};